/* eslint-disable */


function DocumentListingModel($i18n, $http, searchLookups, router) {
    var self = this;

    self.$i18n = $i18n;
    self.$http = $http;

    self.searchLookups = searchLookups;
    self.$router = router;
    self.number = "";
    self.title = "";
    self.yearFrom = "";
    self.yearTo = "";
    self.type = "";
    self.field = "";
    self.sortOrder = 0;
    self.currentUrl = window.location.origin + window.location.pathname + "?";

    self.onFilter = function () {
        self.currentUrl = window.location.origin + window.location.pathname + '?';

        var queryString = '';

        if (self.number) {
            queryString = queryString + "number=" + encodeURIComponent(self.number);
        }
        if (self.title) {
            queryString = queryString + "title=" + encodeURIComponent(self.title);
        }
        if (self.yearFrom) {
            queryString = queryString + "&yearFrom=" + encodeURIComponent(self.yearFrom);
        }
        if (self.yearTo) {
            queryString = queryString + "&yearTo=" + encodeURIComponent(self.yearTo);
        }
        if (self.type) {
            queryString = queryString + "&type=" + encodeURIComponent(self.type);
        }
        if (self.field) {
            queryString = queryString + "&field=" + encodeURIComponent(self.field);
        }
        queryString = queryString + "&pageIndex=0";

        if (self.sortOrder != null) {
            queryString = queryString + "&sortBy=" + parseInt(self.sortOrder);
        }

        window.location.href = self.currentUrl + queryString;
    };
    self.onReset = function () {
        window.location.href = window.location.origin + window.location.pathname + '?pageIndex=0';
    };
    self.onSort = function (sortId) {
        self.sortOrder = sortId;
        self.onFilter();
    };

    (function () {
        self.number = self.number ? self.number : self.$router.history.current.query.number ? self.$router.history.current.query.number : '';
        self.title = self.title ? self.title : self.$router.history.current.query.title ? self.$router.history.current.query.title : '';
        self.yearFrom = self.yearFrom ? self.yearFrom : self.$router.history.current.query.yearFrom ? self.$router.history.current.query.yearFrom : '';
        self.yearTo = self.yearTo ? self.yearTo : self.$router.history.current.query.yearTo ? self.$router.history.current.query.yearTo : '';
        self.type = self.type ? self.type : self.$router.history.current.query.type ? self.$router.history.current.query.type : '';
        self.field = self.field ? self.field : self.$router.history.current.query.field ? self.$router.history.current.query.field : '';

        if (self.$router.history.current.query.sortBy) {
            self.sortOrder = parseInt(self.$router.history.current.query.sortBy);
        }
    })();

    return self;
}

export default DocumentListingModel;
